import React from "react";
import "./HomePage.css";
import Bluearrow from "../assests/blueArrow.png";

function Promoters({ Promoters, setPromoterPopup, setPromoterDetails }) {
  const promotorsString = Promoters?.map(
    ({ promotorName, followers }) => `${promotorName}`
  ).join(", ");

  const handleClickPromoter = (obj) => {
    setPromoterDetails(obj);
    setPromoterPopup(true);
  };
  return (
    // <div className="z-[1]  relative pt-[30px] mb-[32px]">
    //   <div className="flex items-center justify-between">
    //     <p className="text-large-medium">Promoters</p>

    //   </div>
    //   <div className="mt-[12px] flex-wrap overflow-x-auto flex items-center">
    //     {Promoters?.slice(0, 3).map((obj, i) => {
    //       return (
    //         <img
    //           src={obj?.dop}
    //           className="rounded-full w-[60px] h-[60px] object-cover overLap first:ml-0 ml-[-20px] cursor-pointer"
    //           alt=""
    //           onClick={() => handleClickPromoter(obj)}
    //         />
    //       );
    //     })}
    //     {Promoters?.length > 3 && (
    //       <div className="rounded-full w-[60px] h-[60px] object-cover theDarkNumber ml-[-20px]">
    //         +{Promoters?.length - 3}
    //       </div>
    //     )}
    //   </div>
    //   <p className="text-small text_3Line mt-[12px] text-[#CDCDCD]">
    //     {promotorsString}
    //   </p>
    // </div>
    <div className={`z-10  pt-[30px] mb-[32px] relative w-[100%] `}>
      <div className="flex items-center justify-between">
        <p className="text-large-medium">Our Alliance</p>
        {/* <p className="cursor-pointer text-[#0F6ABE] inline-block">
          Details <img className=" inline-block" src={Bluearrow} alt="" />
        </p> */}
      </div>
      <div className="mt-[12px] grid grid-cols-3 gap-x-[5px] gap-y-[12px]">
        {Promoters?.map((obj, i) => {
          return (
            <div
              className="cursor-pointer flex flex-col items-center w-auto"
              onClick={() => handleClickPromoter(obj)}
            >
              <img
                className="rounded-full w-[80px] h-[80px] object-cover judgesBg"
                src={obj?.dop}
                alt=""
              />
              <p className="judgesName">{obj?.promotorName}</p>
              <p className="judjesDes">{obj?.position}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Promoters;
